const LISTS = '/lists';
const ALLOWED_ENTITIES = '/lists/allowed-entities/';
const DENIED_ENTITIES = '/lists/denied-entities/';
const ALLOWED_ORGANIZATIONS = '/lists/allowed-organizations/';
const DENIED_ORGANIZATIONS = '/lists/denied-organizations/';
const ALLOWED_COUNTRIES = '/lists/allowed-countries/';
const DENIED_COUNTRIES = '/lists/denied-countries/';
const NAME_NOISEWORDS = '/lists/name-noisewords/';
const ADDRESS_NOISEWORDS = '/lists/address-noisewords/';
const CONFIGURATION = '/configuration';
const CONFIG_EDIT = '/configuration/edit';
const IMPORT_ENTITIES = '/lists/allowed-entities/import-entities';
const PENDING_CHANGES = 'pending-changes';
const REVIEW_CHANGES = 'review-changes';
const REVISION_HISTORY = 'revision-history';
const REVISION_HISTORY_BY_ID = '/revision-history-by-id';
const SEARCH = '/search';
const BATCH_SCREENING = '/batch-screening';
const UPLOAD_FILE_BATCH_SCREENING = '/batch-screening/upload-file';
const TENANTS = '/tenants';

export const ROUTES: Record<string, any> = {
    SEARCH: {
        INDEX: SEARCH
    },
    BATCH_SCREENING: {
        INDEX: BATCH_SCREENING,
        UPLOAD_FILE_BATCH_SCREENING
    },
    TENANTS: {
        INDEX: TENANTS
    },
    CONFIGURATION: {
        INDEX: CONFIGURATION,
        EDIT: CONFIG_EDIT
    },
    LISTS: {
        INDEX: LISTS,
        ALLOWED_ENTITIES,
        DENIED_ENTITIES,
        ALLOWED_ORGANIZATIONS,
        DENIED_ORGANIZATIONS,
        ALLOWED_COUNTRIES,
        DENIED_COUNTRIES,
        NAME_NOISEWORDS,
        ADDRESS_NOISEWORDS,
        IMPORT_ENTITIES,
        PENDING_CHANGES,
        REVISION_HISTORY,
        REVISION_HISTORY_BY_ID,
        REVIEW_CHANGES
    }
};
